import { utils } from '../../Foundation';

export class DatatableTable {
    constructor(inputSettings) {
        this._refs = {
            el: inputSettings.el,
            table: inputSettings.table,
            eventList: inputSettings.eventList
        }

        this._createTable();
        this._updateTable();
    }

    _createTable() {
        // If this or sub element is a table then return
        if(!this._refs.table) {
            // Create new table
            this._refs.table = utils.createElement('table', { 'class': 'datatable flex-1' }, this._refs.el);
        };
        return;
    }

    _updateTable() {
        this._refs.eventList.updateTable(this._refs.table);
    }
}